module.exports = __webpack_public_path__ + "media/images/copy-e1fff871.png";